<template>
  <div class="home">
    <carousel-head>
    </carousel-head>
    <news-present-area></news-present-area>
    <!-- <servico-box></servico-box> -->
    <empresarial-section></empresarial-section>
    <conexao-box></conexao-box>
    <about-area id="about-us"></about-area>
    <social-bar :mod="true" :telegram="sharedState.cityInfo.telegram.id"></social-bar>
  </div>
</template>

<script>
import CarouselHead from "../components/CarouselHead";
import ServicoBox from "../components/ServicoBox";
import EmpresarialSection from "../components/EmpresarialSection";
import ConexaoBox from "../components/ConexaoBox";
import AboutArea from "../components/AboutArea";
import SocialBar from "../components/SocialBar";
import NewsPresentArea from "../components/NewsPresentArea";

export default {
  name: "home",
  components: {
    NewsPresentArea,
    SocialBar,
    AboutArea,
    ConexaoBox,
    EmpresarialSection,
    // ServicoBox,
    CarouselHead
  },
  data() {
    return {
      sharedState: this.$store.state
    };
  }
};
</script>
